import { render } from "./PosPurchaseReturn.vue?vue&type=template&id=51a3d0e6&scoped=true&ts=true"
import script from "./PosPurchaseReturn.vue?vue&type=script&lang=ts"
export * from "./PosPurchaseReturn.vue?vue&type=script&lang=ts"

import "./PosPurchaseReturn.vue?vue&type=style&index=0&id=51a3d0e6&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a3d0e6"]])

export default __exports__